import { render } from "./ReportItemDetails.vue?vue&type=template&id=db84a4a2"
import script from "./ReportItemDetails.vue?vue&type=script&lang=js"
export * from "./ReportItemDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__